var Kn = Object.defineProperty;
var Yn = (e, t, n) => t in e ? Kn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var rt = (e, t, n) => Yn(e, typeof t != "symbol" ? t + "" : t, n);
function Qn(e, t, n) {
  e.insertBefore(t, n || null);
}
function er(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function tr(e) {
  const t = {};
  for (const r in e)
    t[r] = [n(e[r])];
  function n(r) {
    return function() {
      return {
        c: function() {
        },
        // noop
        m: function(i, a) {
          Qn(i, r.cloneNode(!0), a);
        },
        d: function(i) {
          i && er(r);
        },
        l: function() {
        }
        // noop
      };
    };
  }
  return t;
}
function Dt(e) {
  let t = e.parentElement;
  for (; t; ) {
    if (t.tagName.indexOf("-") !== -1) return t;
    t = t.parentElement;
  }
  return null;
}
function nr(e) {
  let t = document.createDocumentFragment();
  for (; e.firstChild; )
    t.appendChild(e.firstChild);
  return t;
}
const ot = /* @__PURE__ */ new Map(), rr = new MutationObserver((e) => {
  e.forEach((t) => {
    const n = t.target, r = t.attributeName, o = n.getAttribute(r);
    n.forwardAttributeToProp(r, o);
  });
});
function or(e) {
  let t = document.querySelectorAll("[data-svelte-retag-render]");
  if (t.length !== 0)
    for (let n of t)
      n.isConnected && n.parentElement.closest('[data-svelte-retag-render="light"]') === null && (n.removeAttribute("data-svelte-retag-render"), n._renderSvelteComponent());
}
function dn(e) {
  window.customElements.get("svelte-retag") || (window.customElements.define("svelte-retag", class extends HTMLElement {
    // noop
  }), window.customElements.define("svelte-retag-default", class extends HTMLElement {
    // noop
  }));
  let t = () => !1;
  (e == null ? void 0 : e.ignoreCommonAttribWarnings) === !0 ? t = (n) => n === "id" || n === "class" || n === "style" || n.startsWith("data-") : Array.isArray(e.ignoreCommonAttribWarnings) && (t = (n) => e.ignoreCommonAttribWarnings.includes(n)), window.customElements.define(e.tagname, class extends HTMLElement {
    constructor() {
      if (super(), this._debug("constructor()"), this.attributesObserved = !1, e.shadow && (this.attachShadow({ mode: "open" }), this._root = document.createElement("svelte-retag"), this.shadowRoot.appendChild(this._root), e.href)) {
        let n = document.createElement("link");
        n.setAttribute("href", e.href), n.setAttribute("rel", "stylesheet"), this.shadowRoot.appendChild(n);
      }
    }
    /**
     * Attributes we're watching for changes after render (doesn't affect attributes already present prior to render).
     *
     * NOTE: This only applies if opts.attributes is an array. If opts.attributes is true, then all attributes are
     * watched using the mutation observer instead.
     *
     * @returns string[]
     */
    static get observedAttributes() {
      return Array.isArray(e.attributes) ? e.attributes : [];
    }
    /**
     * Attached to DOM.
     */
    connectedCallback() {
      this._debug("connectedCallback()"), this.slotEls = {};
      const n = document.readyState === "loading";
      if (!e.shadow)
        if (this.hasAttribute("data-svelte-retag-hydratable"))
          if (n) {
            this._onSlotsReady(() => {
              this._initLightRoot(), this._hydrateLightSlots(), this._queueForRender();
            });
            return;
          } else
            this._initLightRoot(), this._hydrateLightSlots();
        else
          this._initLightRoot();
      e.shadow ? this._observeSlots(!0) : n && (this._observeSlots(!0), this._onSlotsReady(() => {
        this._observeSlots(!1);
      })), this._queueForRender(), e.hydratable && this.setAttribute("data-svelte-retag-hydratable", "");
    }
    /**
     * Removed from DOM (could be called inside another custom element that starts rendering after this one). In that
     * situation, the connectedCallback() will be executed again (most likely with constructor() as well, unfortunately).
     */
    disconnectedCallback() {
      if (this._debug("disconnectedCallback()"), this.removeAttribute("data-svelte-retag-render"), this.removeAttribute("data-svelte-retag-hydratable"), this._observeSlots(!1), this.componentInstance)
        try {
          this.componentInstance.$destroy(), delete this.componentInstance;
        } catch (n) {
          console.error(`Error destroying Svelte component in '${this.tagName}'s disconnectedCallback(): ${n}`);
        }
      e.shadow || (this._restoreLightSlots(), this.removeChild(this._root));
    }
    /**
     * Callback/hook for observedAttributes.
     *
     * @param {string} name
     * @param {string} oldValue
     * @param {string} newValue
     */
    attributeChangedCallback(n, r, o) {
      this._debug("attributes changed", { name: n, oldValue: r, newValue: o }), this.forwardAttributeToProp(n, o);
    }
    /**
     * Forward modifications to element attributes to the corresponding Svelte prop (if applicable).
     *
     * @param {string} name
     * @param {string} value
     */
    forwardAttributeToProp(n, r) {
      if (this._debug("forwardAttributeToProp", { name: n, value: r }), this.componentInstance) {
        let o = this._translateAttribute(n);
        o !== null && this.componentInstance.$set({ [o]: r });
      }
    }
    /**
     * Setup a wrapper in the light DOM which can keep the rendered Svelte component separate from the default Slot
     * content, which is potentially being actively appended (at least while the browser parses during loading).
     */
    _initLightRoot() {
      let n = this.querySelector("svelte-retag");
      n !== null && n.parentElement === this ? (this._debug("_initLightRoot(): Restore from existing light DOM root"), this._root = n) : (this._root = document.createElement("svelte-retag"), this.prepend(this._root));
    }
    /**
     * Queues the provided callback to execute when we think all slots are fully loaded and available to fetch and
     * manipulate.
     *
     * @param {callback} callback
     */
    _onSlotsReady(n) {
      document.addEventListener("readystatechange", () => {
        document.readyState === "interactive" && n();
      });
    }
    /**
     * Converts the provided lowercase attribute name to the correct case-sensitive component prop name, if possible.
     *
     * @param {string} attributeName
     * @returns {string|null}
     */
    _translateAttribute(n) {
      return n = n.toLowerCase(), this.propMap && this.propMap.has(n) ? this.propMap.get(n) : t(n) ? (this._debug(`_translateAttribute(): ${n} matched ignore filter, skipping entirely`), null) : (this._debug(`_translateAttribute(): ${n} not found on component, keeping unchanged`), n);
    }
    /**
     * To support context, this traverses the DOM to find potential parent elements (also managed by svelte-retag) which
     * may contain context necessary to render this component.
     *
     * See context functions at: https://svelte.dev/docs/svelte#setcontext
     *
     * @returns {Map|null}
     */
    _getAncestorContext() {
      var r, o;
      let n = this;
      for (; n.parentNode; ) {
        n = n.parentNode;
        let i = (o = (r = n == null ? void 0 : n.componentInstance) == null ? void 0 : r.$$) == null ? void 0 : o.context;
        if (i instanceof Map)
          return i;
      }
      return null;
    }
    /**
     * Queue this element for render in the next animation frame. This offers the opportunity to render known available
     * elements all at once and, ideally, from the top down (to preserve context).
     */
    _queueForRender() {
      if (!this.isConnected) {
        this._debug("queueForRender(): skipped, already disconnected");
        return;
      }
      if (this.parentElement.closest('[data-svelte-retag-render="light"]') !== null) {
        this._debug("queueForRender(): skipped, light DOM parent is queued for render");
        return;
      }
      this.setAttribute("data-svelte-retag-render", e.shadow ? "shadow" : "light"), requestAnimationFrame(or);
    }
    /**
     * Renders (or rerenders) the Svelte component into this custom element based on the latest properties and slots
     * (with slots initialized elsewhere).
     *
     * IMPORTANT:
     *
     * Despite the intuitive name, this method is private since its functionality requires a deeper understanding
     * of how it depends on current internal state and how it alters internal state. Be sure to study how it's called
     * before calling it yourself externally. ("Yarrr! Here be dragons! 🔥🐉")
     *
     * That said... this is currently the workflow:
     *
     * 1. Wait for connection to DOM
     * 2. Ensure slots are properly prepared (e.g. in case of hydration) or observed (in case actively parsing DOM, e.g.
     *    IIFE/UMD or shadow DOM) in case there are any changes *after* this render
     * 3. _queueForRender(): Kick off to requestAnimationFrame() to queue render of the component (instead of rendering
     *    immediately) to ensure that all currently connected and available components are taken into account (this is
     *    necessary for properly supporting context to prevent from initializing components out of order).
     * 4. renderElements(): Renders through the DOM tree in document order and from the top down (parent to child),
     *    reaching this element instantiating this component, ensuring context is preserved.
     *
     */
    _renderSvelteComponent() {
      this._debug("renderSvelteComponent()"), e.shadow ? this.slotEls = this._getShadowSlots() : this.slotEls = this._getLightSlots(), this._root.innerHTML = "";
      const n = this._getAncestorContext() || /* @__PURE__ */ new Map();
      let r = {
        $$scope: {},
        // Convert our list of slots into Svelte-specific slot objects
        $$slots: tr(this.slotEls)
        // All other *initial* props are pulled dynamically from element attributes (see proxy below)...
      };
      if (!ot.has(this.tagName))
        this.propMap = /* @__PURE__ */ new Map(), ot.set(this.tagName, this.propMap), r = new Proxy(r, {
          get: (o, i) => {
            let a = i.toString();
            i.indexOf("$$") === -1 && this.propMap.set(a.toLowerCase(), a);
            let s = this.attributes.getNamedItem(a);
            return s !== null ? o[a] = s.value : o[i];
          }
        });
      else {
        this.propMap = ot.get(this.tagName);
        for (let o of [...this.attributes]) {
          if (o.name.startsWith("data-svelte-retag")) continue;
          const i = this._translateAttribute(o.name);
          i !== null && (r[i] = o.value);
        }
      }
      this.componentInstance = new e.component({ target: this._root, props: r, context: n }), e.attributes === !0 && !this.attributesObserved && (this.attributesObserved = !0, this.propMap.size > 0 ? rr.observe(this, {
        attributes: !0,
        // implicit, but... 🤷‍♂️
        attributeFilter: [...this.propMap.keys()]
      }) : this._debug("renderSvelteComponent(): skipped attribute observer, no props")), this._debug("renderSvelteComponent(): completed");
    }
    /**
     * Fetches slots from pre-rendered Svelte component HTML using special markers (either data attributes or custom
     * wrappers). Note that this will only work during initialization and only if the Svelte retag instance is
     * hydratable.
     */
    _hydrateLightSlots() {
      let n = this._root.querySelectorAll("[data-svelte-retag-slot]");
      for (let o of n) {
        if (Dt(o) !== this._root) continue;
        let a = o.getAttribute("slot");
        this.slotEls[a] = o;
      }
      let r = this.querySelector("svelte-retag-default");
      return r !== null && (this.slotEls.default = r), this._restoreLightSlots(), !0;
    }
    /**
     * Indicates if the provided <slot> element instance belongs to this custom element or not.
     *
     * @param {Element} slot
     * @returns {boolean}
     */
    _isOwnSlot(n) {
      let r = Dt(n);
      return r === null ? !1 : r === this;
    }
    /**
     * Returns a map of slot names and the corresponding HTMLElement (named slots) or DocumentFragment (default slots).
     *
     * IMPORTANT: Since this custom element is the "root", these slots must be removed (which is done in THIS method).
     *
     * TODO: Problematic name. We are "getting" but we're also mangling/mutating state (which *is* necessary). "Get" may be confusing here; is there a better name?
     *
     * @returns {SlotList}
     */
    _getLightSlots() {
      this._debug("_getLightSlots()");
      let n = {};
      const r = this.querySelectorAll("[slot]");
      for (let s of r)
        this._isOwnSlot(s) && (n[s.slot] = s, e.hydratable && s.setAttribute("data-svelte-retag-slot", ""), this.removeChild(s));
      let o = document.createDocumentFragment();
      e.hydratable && (o = document.createElement("svelte-retag-default"));
      let i = [...this.childNodes], a = "";
      for (let s of i) {
        if (s instanceof HTMLElement && s.tagName === "SVELTE-RETAG") {
          this._debug("_getLightSlots(): skipping <svelte-retag> container");
          continue;
        }
        s instanceof Text ? a += s.textContent : s.outerHTML && (a += s.outerHTML), o.appendChild(s);
      }
      return a.trim() !== "" && (n.default ? console.error(`svelteRetag: '${this.tagName}': Found elements without slot attribute when using slot="default"`) : n.default = o), n;
    }
    /**
     * Go through originally removed slots and restore back to the custom element.
     */
    _restoreLightSlots() {
      this._debug("_restoreLightSlots:", this.slotEls);
      for (let n in this.slotEls) {
        let r = this.slotEls[n];
        r.tagName === "SVELTE-RETAG-DEFAULT" ? this.prepend(nr(r)) : (this.prepend(r), r instanceof HTMLElement && r.hasAttribute("data-svelte-retag-slot") && r.removeAttribute("data-svelte-retag-slot"));
      }
      this.slotEls = {};
    }
    /**
     * Fetches and returns references to the existing shadow DOM slots. Left unmodified.
     *
     * @returns {SlotList}
     */
    _getShadowSlots() {
      this._debug("_getShadowSlots()");
      const n = this.querySelectorAll("[slot]");
      let r = {}, o = this.innerHTML.length;
      return n.forEach((i) => {
        r[i.slot] = document.createElement("slot"), r[i.slot].setAttribute("name", i.slot), o -= i.outerHTML.length;
      }), o > 0 && (r.default = document.createElement("slot")), r;
    }
    /**
     * Toggle on/off the MutationObserver used to watch for changes in child slots.
     */
    _observeSlots(n) {
      n !== this.slotObserverActive && (this.slotObserver || (this.slotObserver = new MutationObserver((r) => {
        this._processSlotMutations(r);
      })), n ? (this.slotObserver.observe(this, { childList: !0, subtree: !1, attributes: !1 }), this._debug("_observeSlots: OBSERVE")) : (this.slotObserver.disconnect(), this._debug("_observeSlots: DISCONNECT")), this.slotObserverActive = n);
    }
    /**
     * Watches for slot changes, specifically:
     *
     * 1. Shadow DOM: All slot changes will queue a rerender of the Svelte component
     *
     * 2. Light DOM: Only additions will be accounted for. This is particularly because currently we only support
     *    watching for changes during document parsing (i.e. document.readyState === 'loading', prior to the
     *    'DOMContentLoaded' event.
     *
     * @param {MutationRecord[]} mutations
     */
    _processSlotMutations(n) {
      this._debug("_processSlotMutations()", n);
      let r = !1;
      for (let o of n)
        if (o.type === "childList") {
          if (e.shadow) {
            r = !0;
            break;
          } else if (o.addedNodes.length > 0) {
            r = !0;
            break;
          }
        }
      r && (e.shadow || (this._observeSlots(!1), this._restoreLightSlots(), this._observeSlots(!0)), this._debug("_processMutations(): Queue rerender"), this._queueForRender());
    }
    /**
     * Pass through to console.log() but includes a reference to the custom element in the log for easier targeting for
     * debugging purposes.
     *
     * @param {...*}
     */
    _debug() {
      e.debugMode && (e.debugMode === "cli" ? console.log.apply(null, [performance.now(), this.tagName, ...arguments]) : console.log.apply(null, [performance.now(), this, ...arguments]));
    }
  });
}
function U() {
}
function ir(e, t) {
  for (const n in t) e[n] = t[n];
  return (
    /** @type {T & S} */
    e
  );
}
function fn(e) {
  return e();
}
function Ut() {
  return /* @__PURE__ */ Object.create(null);
}
function ee(e) {
  e.forEach(fn);
}
function xt(e) {
  return typeof e == "function";
}
function wt(e, t) {
  return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
function ar(e) {
  return Object.keys(e).length === 0;
}
function mn(e, ...t) {
  if (e == null) {
    for (const r of t)
      r(void 0);
    return U;
  }
  const n = e.subscribe(...t);
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
function pn(e, t, n) {
  e.$$.on_destroy.push(mn(t, n));
}
function sr(e, t, n, r) {
  if (e) {
    const o = gn(e, t, n, r);
    return e[0](o);
  }
}
function gn(e, t, n, r) {
  return e[1] && r ? ir(n.ctx.slice(), e[1](r(t))) : n.ctx;
}
function lr(e, t, n, r) {
  if (e[2] && r) {
    const o = e[2](r(n));
    if (t.dirty === void 0)
      return o;
    if (typeof o == "object") {
      const i = [], a = Math.max(t.dirty.length, o.length);
      for (let s = 0; s < a; s += 1)
        i[s] = t.dirty[s] | o[s];
      return i;
    }
    return t.dirty | o;
  }
  return t.dirty;
}
function ur(e, t, n, r, o, i) {
  if (o) {
    const a = gn(t, n, r, i);
    e.p(a, o);
  }
}
function cr(e) {
  if (e.ctx.length > 32) {
    const t = [], n = e.ctx.length / 32;
    for (let r = 0; r < n; r++)
      t[r] = -1;
    return t;
  }
  return -1;
}
function f(e, t) {
  e.appendChild(t);
}
function bn(e, t, n) {
  const r = hr(e);
  if (!r.getElementById(t)) {
    const o = v("style");
    o.id = t, o.textContent = n, dr(r, o);
  }
}
function hr(e) {
  if (!e) return document;
  const t = e.getRootNode ? e.getRootNode() : e.ownerDocument;
  return t && /** @type {ShadowRoot} */
  t.host ? (
    /** @type {ShadowRoot} */
    t
  ) : e.ownerDocument;
}
function dr(e, t) {
  return f(
    /** @type {Document} */
    e.head || e,
    t
  ), t.sheet;
}
function I(e, t, n) {
  e.insertBefore(t, n || null);
}
function M(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function Tt(e, t) {
  for (let n = 0; n < e.length; n += 1)
    e[n] && e[n].d(t);
}
function v(e) {
  return document.createElement(e);
}
function C(e) {
  return document.createTextNode(e);
}
function O() {
  return C(" ");
}
function vn() {
  return C("");
}
function z(e, t, n, r) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r);
}
function dt(e) {
  return function(t) {
    return t.preventDefault(), e.call(this, t);
  };
}
function m(e, t, n) {
  n == null ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n);
}
function fr(e) {
  return Array.from(e.childNodes);
}
function D(e, t) {
  t = "" + t, e.data !== t && (e.data = /** @type {string} */
  t);
}
function X(e, t) {
  e.value = t ?? "";
}
function Ft(e, t, n) {
  for (let r = 0; r < e.options.length; r += 1) {
    const o = e.options[r];
    if (o.__value === t) {
      o.selected = !0;
      return;
    }
  }
  (!n || t !== void 0) && (e.selectedIndex = -1);
}
function mr(e) {
  const t = e.querySelector(":checked");
  return t && t.__value;
}
let At;
function Te(e) {
  At = e;
}
const le = [], kt = [];
let ue = [];
const jt = [], pr = /* @__PURE__ */ Promise.resolve();
let ft = !1;
function gr() {
  ft || (ft = !0, pr.then(_n));
}
function je(e) {
  ue.push(e);
}
const it = /* @__PURE__ */ new Set();
let ae = 0;
function _n() {
  if (ae !== 0)
    return;
  const e = At;
  do {
    try {
      for (; ae < le.length; ) {
        const t = le[ae];
        ae++, Te(t), br(t.$$);
      }
    } catch (t) {
      throw le.length = 0, ae = 0, t;
    }
    for (Te(null), le.length = 0, ae = 0; kt.length; ) kt.pop()();
    for (let t = 0; t < ue.length; t += 1) {
      const n = ue[t];
      it.has(n) || (it.add(n), n());
    }
    ue.length = 0;
  } while (le.length);
  for (; jt.length; )
    jt.pop()();
  ft = !1, it.clear(), Te(e);
}
function br(e) {
  if (e.fragment !== null) {
    e.update(), ee(e.before_update);
    const t = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(je);
  }
}
function vr(e) {
  const t = [], n = [];
  ue.forEach((r) => e.indexOf(r) === -1 ? t.push(r) : n.push(r)), n.forEach((r) => r()), ue = t;
}
const Ue = /* @__PURE__ */ new Set();
let oe;
function _r() {
  oe = {
    r: 0,
    c: [],
    p: oe
    // parent group
  };
}
function yr() {
  oe.r || ee(oe.c), oe = oe.p;
}
function Ve(e, t) {
  e && e.i && (Ue.delete(e), e.i(t));
}
function mt(e, t, n, r) {
  if (e && e.o) {
    if (Ue.has(e)) return;
    Ue.add(e), oe.c.push(() => {
      Ue.delete(e), r && (n && e.d(1), r());
    }), e.o(t);
  } else r && r();
}
function ce(e) {
  return (e == null ? void 0 : e.length) !== void 0 ? e : Array.from(e);
}
function Er(e, t, n) {
  const { fragment: r, after_update: o } = e.$$;
  r && r.m(t, n), je(() => {
    const i = e.$$.on_mount.map(fn).filter(xt);
    e.$$.on_destroy ? e.$$.on_destroy.push(...i) : ee(i), e.$$.on_mount = [];
  }), o.forEach(je);
}
function Sr(e, t) {
  const n = e.$$;
  n.fragment !== null && (vr(n.after_update), ee(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []);
}
function xr(e, t) {
  e.$$.dirty[0] === -1 && (le.push(e), gr(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function yn(e, t, n, r, o, i, a = null, s = [-1]) {
  const c = At;
  Te(e);
  const l = e.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: i,
    update: U,
    not_equal: o,
    bound: Ut(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (c ? c.$$.context : [])),
    // everything else
    callbacks: Ut(),
    dirty: s,
    skip_bound: !1,
    root: t.target || c.$$.root
  };
  a && a(l.root);
  let u = !1;
  if (l.ctx = n ? n(e, t.props || {}, (h, d, ...p) => {
    const g = p.length ? p[0] : d;
    return l.ctx && o(l.ctx[h], l.ctx[h] = g) && (!l.skip_bound && l.bound[h] && l.bound[h](g), u && xr(e, h)), d;
  }) : [], l.update(), u = !0, ee(l.before_update), l.fragment = r ? r(l.ctx) : !1, t.target) {
    if (t.hydrate) {
      const h = fr(t.target);
      l.fragment && l.fragment.l(h), h.forEach(M);
    } else
      l.fragment && l.fragment.c();
    t.intro && Ve(e.$$.fragment), Er(e, t.target, t.anchor), _n();
  }
  Te(c);
}
class En {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    rt(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    rt(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    Sr(this, 1), this.$destroy = U;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(t, n) {
    if (!xt(n))
      return U;
    const r = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return r.push(n), () => {
      const o = r.indexOf(n);
      o !== -1 && r.splice(o, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(t) {
    this.$$set && !ar(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
}
const wr = "4", se = [];
function Tr(e, t) {
  return {
    subscribe: Xe(e, t).subscribe
  };
}
function Xe(e, t = U) {
  let n;
  const r = /* @__PURE__ */ new Set();
  function o(s) {
    if (wt(e, s) && (e = s, n)) {
      const c = !se.length;
      for (const l of r)
        l[1](), se.push(l, e);
      if (c) {
        for (let l = 0; l < se.length; l += 2)
          se[l][0](se[l + 1]);
        se.length = 0;
      }
    }
  }
  function i(s) {
    o(s(e));
  }
  function a(s, c = U) {
    const l = [s, c];
    return r.add(l), r.size === 1 && (n = t(o, i) || U), s(e), () => {
      r.delete(l), r.size === 0 && n && (n(), n = null);
    };
  }
  return { set: o, update: i, subscribe: a };
}
function be(e, t, n) {
  const r = !Array.isArray(e), o = r ? [e] : e;
  if (!o.every(Boolean))
    throw new Error("derived() expects stores as input, got a falsy value");
  const i = t.length < 2;
  return Tr(n, (a, s) => {
    let c = !1;
    const l = [];
    let u = 0, h = U;
    const d = () => {
      if (u)
        return;
      h();
      const g = t(r ? l[0] : l, a, s);
      i ? a(g) : h = xt(g) ? g : U;
    }, p = o.map(
      (g, b) => mn(
        g,
        (P) => {
          l[b] = P, u &= ~(1 << b), c && d();
        },
        () => {
          u |= 1 << b;
        }
      )
    );
    return c = !0, d(), function() {
      ee(p), h(), c = !1;
    };
  });
}
function Ar(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Br = function(t) {
  return Hr(t) && !Nr(t);
};
function Hr(e) {
  return !!e && typeof e == "object";
}
function Nr(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || Pr(e);
}
var Lr = typeof Symbol == "function" && Symbol.for, Mr = Lr ? Symbol.for("react.element") : 60103;
function Pr(e) {
  return e.$$typeof === Mr;
}
function Or(e) {
  return Array.isArray(e) ? [] : {};
}
function He(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? he(Or(e), e, t) : e;
}
function Cr(e, t, n) {
  return e.concat(t).map(function(r) {
    return He(r, n);
  });
}
function Ir(e, t) {
  if (!t.customMerge)
    return he;
  var n = t.customMerge(e);
  return typeof n == "function" ? n : he;
}
function Rr(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function Vt(e) {
  return Object.keys(e).concat(Rr(e));
}
function Sn(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function Gr(e, t) {
  return Sn(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function Dr(e, t, n) {
  var r = {};
  return n.isMergeableObject(e) && Vt(e).forEach(function(o) {
    r[o] = He(e[o], n);
  }), Vt(t).forEach(function(o) {
    Gr(e, o) || (Sn(e, o) && n.isMergeableObject(t[o]) ? r[o] = Ir(o, n)(e[o], t[o], n) : r[o] = He(t[o], n));
  }), r;
}
function he(e, t, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || Cr, n.isMergeableObject = n.isMergeableObject || Br, n.cloneUnlessOtherwiseSpecified = He;
  var r = Array.isArray(t), o = Array.isArray(e), i = r === o;
  return i ? r ? n.arrayMerge(e, t, n) : Dr(e, t, n) : He(t, n);
}
he.all = function(t, n) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(r, o) {
    return he(r, o, n);
  }, {});
};
var Ur = he, Fr = Ur;
const kr = /* @__PURE__ */ Ar(Fr);
var pt = function(e, t) {
  return pt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, pt(e, t);
};
function Ze(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  pt(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var S = function() {
  return S = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, S.apply(this, arguments);
};
function jr(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function at(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function st(e, t) {
  var n = t && t.cache ? t.cache : Zr, r = t && t.serializer ? t.serializer : Xr, o = t && t.strategy ? t.strategy : $r;
  return o(e, {
    cache: n,
    serializer: r
  });
}
function Vr(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function xn(e, t, n, r) {
  var o = Vr(r) ? r : n(r), i = t.get(o);
  return typeof i > "u" && (i = e.call(this, r), t.set(o, i)), i;
}
function wn(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), o = n(r), i = t.get(o);
  return typeof i > "u" && (i = e.apply(this, r), t.set(o, i)), i;
}
function Bt(e, t, n, r, o) {
  return n.bind(t, e, r, o);
}
function $r(e, t) {
  var n = e.length === 1 ? xn : wn;
  return Bt(e, this, n, t.cache.create(), t.serializer);
}
function Wr(e, t) {
  return Bt(e, this, wn, t.cache.create(), t.serializer);
}
function zr(e, t) {
  return Bt(e, this, xn, t.cache.create(), t.serializer);
}
var Xr = function() {
  return JSON.stringify(arguments);
};
function Ht() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
Ht.prototype.get = function(e) {
  return this.cache[e];
};
Ht.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var Zr = {
  create: function() {
    return new Ht();
  }
}, lt = {
  variadic: Wr,
  monadic: zr
}, _;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(_ || (_ = {}));
var A;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(A || (A = {}));
var de;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(de || (de = {}));
function $t(e) {
  return e.type === A.literal;
}
function qr(e) {
  return e.type === A.argument;
}
function Tn(e) {
  return e.type === A.number;
}
function An(e) {
  return e.type === A.date;
}
function Bn(e) {
  return e.type === A.time;
}
function Hn(e) {
  return e.type === A.select;
}
function Nn(e) {
  return e.type === A.plural;
}
function Jr(e) {
  return e.type === A.pound;
}
function Ln(e) {
  return e.type === A.tag;
}
function Mn(e) {
  return !!(e && typeof e == "object" && e.type === de.number);
}
function gt(e) {
  return !!(e && typeof e == "object" && e.type === de.dateTime);
}
var Pn = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Kr = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Yr(e) {
  var t = {};
  return e.replace(Kr, function(n) {
    var r = n.length;
    switch (n[0]) {
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var Qr = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function eo(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(Qr).filter(function(d) {
    return d.length > 0;
  }), n = [], r = 0, o = t; r < o.length; r++) {
    var i = o[r], a = i.split("/");
    if (a.length === 0)
      throw new Error("Invalid number skeleton");
    for (var s = a[0], c = a.slice(1), l = 0, u = c; l < u.length; l++) {
      var h = u[l];
      if (h.length === 0)
        throw new Error("Invalid number skeleton");
    }
    n.push({ stem: s, options: c });
  }
  return n;
}
function to(e) {
  return e.replace(/^(.*?)-/, "");
}
var Wt = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, On = /^(@+)?(\+|#+)?[rs]?$/g, no = /(\*)(0+)|(#+)(0+)|(0+)/g, Cn = /^(0+)$/;
function zt(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(On, function(n, r, o) {
    return typeof o != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : o === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof o == "string" ? o.length : 0)), "";
  }), t;
}
function In(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function ro(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !Cn.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Xt(e) {
  var t = {}, n = In(e);
  return n || t;
}
function oo(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var o = r[n];
    switch (o.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = o.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = to(o.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = S(S(S({}, t), { notation: "scientific" }), o.options.reduce(function(c, l) {
          return S(S({}, c), Xt(l));
        }, {}));
        continue;
      case "engineering":
        t = S(S(S({}, t), { notation: "engineering" }), o.options.reduce(function(c, l) {
          return S(S({}, c), Xt(l));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(o.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (o.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        o.options[0].replace(no, function(c, l, u, h, d, p) {
          if (l)
            t.minimumIntegerDigits = u.length;
          else {
            if (h && d)
              throw new Error("We currently do not support maximum integer digits");
            if (p)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (Cn.test(o.stem)) {
      t.minimumIntegerDigits = o.stem.length;
      continue;
    }
    if (Wt.test(o.stem)) {
      if (o.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      o.stem.replace(Wt, function(c, l, u, h, d, p) {
        return u === "*" ? t.minimumFractionDigits = l.length : h && h[0] === "#" ? t.maximumFractionDigits = h.length : d && p ? (t.minimumFractionDigits = d.length, t.maximumFractionDigits = d.length + p.length) : (t.minimumFractionDigits = l.length, t.maximumFractionDigits = l.length), "";
      });
      var i = o.options[0];
      i === "w" ? t = S(S({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = S(S({}, t), zt(i)));
      continue;
    }
    if (On.test(o.stem)) {
      t = S(S({}, t), zt(o.stem));
      continue;
    }
    var a = In(o.stem);
    a && (t = S(S({}, t), a));
    var s = ro(o.stem);
    s && (t = S(S({}, t), s));
  }
  return t;
}
var De = {
  "001": [
    "H",
    "h"
  ],
  419: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CU: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-HK": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-IL": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "en-MY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function io(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var o = e.charAt(r);
    if (o === "j") {
      for (var i = 0; r + 1 < e.length && e.charAt(r + 1) === o; )
        i++, r++;
      var a = 1 + (i & 1), s = i < 2 ? 1 : 3 + (i >> 1), c = "a", l = ao(t);
      for ((l == "H" || l == "k") && (s = 0); s-- > 0; )
        n += c;
      for (; a-- > 0; )
        n = l + n;
    } else o === "J" ? n += "H" : n += o;
  }
  return n;
}
function ao(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var n = e.language, r;
  n !== "root" && (r = e.maximize().region);
  var o = De[r || ""] || De[n || ""] || De["".concat(n, "-001")] || De["001"];
  return o[0];
}
var ut, so = new RegExp("^".concat(Pn.source, "*")), lo = new RegExp("".concat(Pn.source, "*$"));
function E(e, t) {
  return { start: e, end: t };
}
var uo = !!String.prototype.startsWith && "_a".startsWith("a", 1), co = !!String.fromCodePoint, ho = !!Object.fromEntries, fo = !!String.prototype.codePointAt, mo = !!String.prototype.trimStart, po = !!String.prototype.trimEnd, go = !!Number.isSafeInteger, bo = go ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, bt = !0;
try {
  var vo = Gn("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  bt = ((ut = vo.exec("a")) === null || ut === void 0 ? void 0 : ut[0]) === "a";
} catch {
  bt = !1;
}
var Zt = uo ? (
  // Native
  function(t, n, r) {
    return t.startsWith(n, r);
  }
) : (
  // For IE11
  function(t, n, r) {
    return t.slice(r, r + n.length) === n;
  }
), vt = co ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    for (var r = "", o = t.length, i = 0, a; o > i; ) {
      if (a = t[i++], a > 1114111)
        throw RangeError(a + " is not a valid code point");
      r += a < 65536 ? String.fromCharCode(a) : String.fromCharCode(((a -= 65536) >> 10) + 55296, a % 1024 + 56320);
    }
    return r;
  }
), qt = (
  // native
  ho ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var n = {}, r = 0, o = t; r < o.length; r++) {
        var i = o[r], a = i[0], s = i[1];
        n[a] = s;
      }
      return n;
    }
  )
), Rn = fo ? (
  // Native
  function(t, n) {
    return t.codePointAt(n);
  }
) : (
  // IE 11
  function(t, n) {
    var r = t.length;
    if (!(n < 0 || n >= r)) {
      var o = t.charCodeAt(n), i;
      return o < 55296 || o > 56319 || n + 1 === r || (i = t.charCodeAt(n + 1)) < 56320 || i > 57343 ? o : (o - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), _o = mo ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(so, "");
  }
), yo = po ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(lo, "");
  }
);
function Gn(e, t) {
  return new RegExp(e, t);
}
var _t;
if (bt) {
  var Jt = Gn("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  _t = function(t, n) {
    var r;
    Jt.lastIndex = n;
    var o = Jt.exec(t);
    return (r = o[1]) !== null && r !== void 0 ? r : "";
  };
} else
  _t = function(t, n) {
    for (var r = []; ; ) {
      var o = Rn(t, n);
      if (o === void 0 || Dn(o) || wo(o))
        break;
      r.push(o), n += o >= 65536 ? 2 : 1;
    }
    return vt.apply(void 0, r);
  };
var Eo = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, n, r) {
      for (var o = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var a = this.parseArgument(t, r);
          if (a.err)
            return a;
          o.push(a.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (n === "plural" || n === "selectordinal")) {
            var s = this.clonePosition();
            this.bump(), o.push({
              type: A.pound,
              location: E(s, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (r)
              break;
            return this.error(_.UNMATCHED_CLOSING_TAG, E(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && yt(this.peek() || 0)) {
            var a = this.parseTag(t, n);
            if (a.err)
              return a;
            o.push(a.val);
          } else {
            var a = this.parseLiteral(t, n);
            if (a.err)
              return a;
            o.push(a.val);
          }
        }
      }
      return { val: o, err: null };
    }, e.prototype.parseTag = function(t, n) {
      var r = this.clonePosition();
      this.bump();
      var o = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: A.literal,
            value: "<".concat(o, "/>"),
            location: E(r, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, n, !0);
        if (i.err)
          return i;
        var a = i.val, s = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !yt(this.char()))
            return this.error(_.INVALID_TAG, E(s, this.clonePosition()));
          var c = this.clonePosition(), l = this.parseTagName();
          return o !== l ? this.error(_.UNMATCHED_CLOSING_TAG, E(c, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: A.tag,
              value: o,
              children: a,
              location: E(r, this.clonePosition())
            },
            err: null
          } : this.error(_.INVALID_TAG, E(s, this.clonePosition())));
        } else
          return this.error(_.UNCLOSED_TAG, E(r, this.clonePosition()));
      } else
        return this.error(_.INVALID_TAG, E(r, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && xo(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, n) {
      for (var r = this.clonePosition(), o = ""; ; ) {
        var i = this.tryParseQuote(n);
        if (i) {
          o += i;
          continue;
        }
        var a = this.tryParseUnquoted(t, n);
        if (a) {
          o += a;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          o += s;
          continue;
        }
        break;
      }
      var c = E(r, this.clonePosition());
      return {
        val: { type: A.literal, value: o, location: c },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !So(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var r = this.char();
        if (r === 39)
          if (this.peek() === 39)
            n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          n.push(r);
        this.bump();
      }
      return vt.apply(void 0, n);
    }, e.prototype.tryParseUnquoted = function(t, n) {
      if (this.isEOF())
        return null;
      var r = this.char();
      return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), vt(r));
    }, e.prototype.parseArgument = function(t, n) {
      var r = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(_.EXPECT_ARGUMENT_CLOSING_BRACE, E(r, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(_.EMPTY_ARGUMENT, E(r, this.clonePosition()));
      var o = this.parseIdentifierIfPossible().value;
      if (!o)
        return this.error(_.MALFORMED_ARGUMENT, E(r, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(_.EXPECT_ARGUMENT_CLOSING_BRACE, E(r, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: A.argument,
              // value does not include the opening and closing braces.
              value: o,
              location: E(r, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(_.EXPECT_ARGUMENT_CLOSING_BRACE, E(r, this.clonePosition())) : this.parseArgumentOptions(t, n, o, r);
        default:
          return this.error(_.MALFORMED_ARGUMENT, E(r, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), n = this.offset(), r = _t(this.message, n), o = n + r.length;
      this.bumpTo(o);
      var i = this.clonePosition(), a = E(t, i);
      return { value: r, location: a };
    }, e.prototype.parseArgumentOptions = function(t, n, r, o) {
      var i, a = this.clonePosition(), s = this.parseIdentifierIfPossible().value, c = this.clonePosition();
      switch (s) {
        case "":
          return this.error(_.EXPECT_ARGUMENT_TYPE, E(a, c));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var l = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var u = this.clonePosition(), h = this.parseSimpleArgStyleIfPossible();
            if (h.err)
              return h;
            var d = yo(h.val);
            if (d.length === 0)
              return this.error(_.EXPECT_ARGUMENT_STYLE, E(this.clonePosition(), this.clonePosition()));
            var p = E(u, this.clonePosition());
            l = { style: d, styleLocation: p };
          }
          var g = this.tryParseArgumentClose(o);
          if (g.err)
            return g;
          var b = E(o, this.clonePosition());
          if (l && Zt(l == null ? void 0 : l.style, "::", 0)) {
            var P = _o(l.style.slice(2));
            if (s === "number") {
              var h = this.parseNumberSkeletonFromString(P, l.styleLocation);
              return h.err ? h : {
                val: { type: A.number, value: r, location: b, style: h.val },
                err: null
              };
            } else {
              if (P.length === 0)
                return this.error(_.EXPECT_DATE_TIME_SKELETON, b);
              var R = P;
              this.locale && (R = io(P, this.locale));
              var d = {
                type: de.dateTime,
                pattern: R,
                location: l.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? Yr(R) : {}
              }, x = s === "date" ? A.date : A.time;
              return {
                val: { type: x, value: r, location: b, style: d },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? A.number : s === "date" ? A.date : A.time,
              value: r,
              location: b,
              style: (i = l == null ? void 0 : l.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var y = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(_.EXPECT_SELECT_ARGUMENT_OPTIONS, E(y, S({}, y)));
          this.bumpSpace();
          var w = this.parseIdentifierIfPossible(), V = 0;
          if (s !== "select" && w.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(_.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, E(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var h = this.tryParseDecimalInteger(_.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, _.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (h.err)
              return h;
            this.bumpSpace(), w = this.parseIdentifierIfPossible(), V = h.val;
          }
          var j = this.tryParsePluralOrSelectOptions(t, s, n, w);
          if (j.err)
            return j;
          var g = this.tryParseArgumentClose(o);
          if (g.err)
            return g;
          var Z = E(o, this.clonePosition());
          return s === "select" ? {
            val: {
              type: A.select,
              value: r,
              options: qt(j.val),
              location: Z
            },
            err: null
          } : {
            val: {
              type: A.plural,
              value: r,
              options: qt(j.val),
              offset: V,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: Z
            },
            err: null
          };
        }
        default:
          return this.error(_.INVALID_ARGUMENT_TYPE, E(a, c));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(_.EXPECT_ARGUMENT_CLOSING_BRACE, E(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var r = this.char();
        switch (r) {
          case 39: {
            this.bump();
            var o = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(_.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, E(o, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(n.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(n.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, n) {
      var r = [];
      try {
        r = eo(t);
      } catch {
        return this.error(_.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: {
          type: de.number,
          tokens: r,
          location: n,
          parsedOptions: this.shouldParseSkeletons ? oo(r) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, n, r, o) {
      for (var i, a = !1, s = [], c = /* @__PURE__ */ new Set(), l = o.value, u = o.location; ; ) {
        if (l.length === 0) {
          var h = this.clonePosition();
          if (n !== "select" && this.bumpIf("=")) {
            var d = this.tryParseDecimalInteger(_.EXPECT_PLURAL_ARGUMENT_SELECTOR, _.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (d.err)
              return d;
            u = E(h, this.clonePosition()), l = this.message.slice(h.offset, this.offset());
          } else
            break;
        }
        if (c.has(l))
          return this.error(n === "select" ? _.DUPLICATE_SELECT_ARGUMENT_SELECTOR : _.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, u);
        l === "other" && (a = !0), this.bumpSpace();
        var p = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(n === "select" ? _.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : _.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, E(this.clonePosition(), this.clonePosition()));
        var g = this.parseMessage(t + 1, n, r);
        if (g.err)
          return g;
        var b = this.tryParseArgumentClose(p);
        if (b.err)
          return b;
        s.push([
          l,
          {
            value: g.val,
            location: E(p, this.clonePosition())
          }
        ]), c.add(l), this.bumpSpace(), i = this.parseIdentifierIfPossible(), l = i.value, u = i.location;
      }
      return s.length === 0 ? this.error(n === "select" ? _.EXPECT_SELECT_ARGUMENT_SELECTOR : _.EXPECT_PLURAL_ARGUMENT_SELECTOR, E(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !a ? this.error(_.MISSING_OTHER_CLAUSE, E(this.clonePosition(), this.clonePosition())) : { val: s, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, n) {
      var r = 1, o = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (r = -1);
      for (var i = !1, a = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57)
          i = !0, a = a * 10 + (s - 48), this.bump();
        else
          break;
      }
      var c = E(o, this.clonePosition());
      return i ? (a *= r, bo(a) ? { val: a, err: null } : this.error(n, c)) : this.error(t, c);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var n = Rn(this.message, t);
      if (n === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return n;
    }, e.prototype.error = function(t, n) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: n
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (Zt(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var n = this.offset(), r = this.message.indexOf(t, n);
      return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t)
          break;
        if (n > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && Dn(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), n = this.offset(), r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return r ?? null;
    }, e;
  }()
);
function yt(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function So(e) {
  return yt(e) || e === 47;
}
function xo(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function Dn(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function wo(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function Et(e) {
  e.forEach(function(t) {
    if (delete t.location, Hn(t) || Nn(t))
      for (var n in t.options)
        delete t.options[n].location, Et(t.options[n].value);
    else Tn(t) && Mn(t.style) || (An(t) || Bn(t)) && gt(t.style) ? delete t.style.location : Ln(t) && Et(t.children);
  });
}
function To(e, t) {
  t === void 0 && (t = {}), t = S({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var n = new Eo(e, t).parse();
  if (n.err) {
    var r = SyntaxError(_[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t != null && t.captureLocation || Et(n.val), n.val;
}
var fe;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(fe || (fe = {}));
var qe = (
  /** @class */
  function(e) {
    Ze(t, e);
    function t(n, r, o) {
      var i = e.call(this, n) || this;
      return i.code = r, i.originalMessage = o, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), Kt = (
  /** @class */
  function(e) {
    Ze(t, e);
    function t(n, r, o, i) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(o).join('", "'), '"'), fe.INVALID_VALUE, i) || this;
    }
    return t;
  }(qe)
), Ao = (
  /** @class */
  function(e) {
    Ze(t, e);
    function t(n, r, o) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), fe.INVALID_VALUE, o) || this;
    }
    return t;
  }(qe)
), Bo = (
  /** @class */
  function(e) {
    Ze(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), fe.MISSING_VALUE, r) || this;
    }
    return t;
  }(qe)
), G;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(G || (G = {}));
function Ho(e) {
  return e.length < 2 ? e : e.reduce(function(t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== G.literal || n.type !== G.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function No(e) {
  return typeof e == "function";
}
function Fe(e, t, n, r, o, i, a) {
  if (e.length === 1 && $t(e[0]))
    return [
      {
        type: G.literal,
        value: e[0].value
      }
    ];
  for (var s = [], c = 0, l = e; c < l.length; c++) {
    var u = l[c];
    if ($t(u)) {
      s.push({
        type: G.literal,
        value: u.value
      });
      continue;
    }
    if (Jr(u)) {
      typeof i == "number" && s.push({
        type: G.literal,
        value: n.getNumberFormat(t).format(i)
      });
      continue;
    }
    var h = u.value;
    if (!(o && h in o))
      throw new Bo(h, a);
    var d = o[h];
    if (qr(u)) {
      (!d || typeof d == "string" || typeof d == "number") && (d = typeof d == "string" || typeof d == "number" ? String(d) : ""), s.push({
        type: typeof d == "string" ? G.literal : G.object,
        value: d
      });
      continue;
    }
    if (An(u)) {
      var p = typeof u.style == "string" ? r.date[u.style] : gt(u.style) ? u.style.parsedOptions : void 0;
      s.push({
        type: G.literal,
        value: n.getDateTimeFormat(t, p).format(d)
      });
      continue;
    }
    if (Bn(u)) {
      var p = typeof u.style == "string" ? r.time[u.style] : gt(u.style) ? u.style.parsedOptions : r.time.medium;
      s.push({
        type: G.literal,
        value: n.getDateTimeFormat(t, p).format(d)
      });
      continue;
    }
    if (Tn(u)) {
      var p = typeof u.style == "string" ? r.number[u.style] : Mn(u.style) ? u.style.parsedOptions : void 0;
      p && p.scale && (d = d * (p.scale || 1)), s.push({
        type: G.literal,
        value: n.getNumberFormat(t, p).format(d)
      });
      continue;
    }
    if (Ln(u)) {
      var g = u.children, b = u.value, P = o[b];
      if (!No(P))
        throw new Ao(b, "function", a);
      var R = Fe(g, t, n, r, o, i), x = P(R.map(function(V) {
        return V.value;
      }));
      Array.isArray(x) || (x = [x]), s.push.apply(s, x.map(function(V) {
        return {
          type: typeof V == "string" ? G.literal : G.object,
          value: V
        };
      }));
    }
    if (Hn(u)) {
      var y = u.options[d] || u.options.other;
      if (!y)
        throw new Kt(u.value, d, Object.keys(u.options), a);
      s.push.apply(s, Fe(y.value, t, n, r, o));
      continue;
    }
    if (Nn(u)) {
      var y = u.options["=".concat(d)];
      if (!y) {
        if (!Intl.PluralRules)
          throw new qe(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, fe.MISSING_INTL_API, a);
        var w = n.getPluralRules(t, { type: u.pluralType }).select(d - (u.offset || 0));
        y = u.options[w] || u.options.other;
      }
      if (!y)
        throw new Kt(u.value, d, Object.keys(u.options), a);
      s.push.apply(s, Fe(y.value, t, n, r, o, d - (u.offset || 0)));
      continue;
    }
  }
  return Ho(s);
}
function Lo(e, t) {
  return t ? S(S(S({}, e || {}), t || {}), Object.keys(e).reduce(function(n, r) {
    return n[r] = S(S({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function Mo(e, t) {
  return t ? Object.keys(e).reduce(function(n, r) {
    return n[r] = Lo(e[r], t[r]), n;
  }, S({}, e)) : e;
}
function ct(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function Po(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: st(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, at([void 0], n, !1)))();
    }, {
      cache: ct(e.number),
      strategy: lt.variadic
    }),
    getDateTimeFormat: st(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, at([void 0], n, !1)))();
    }, {
      cache: ct(e.dateTime),
      strategy: lt.variadic
    }),
    getPluralRules: st(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, at([void 0], n, !1)))();
    }, {
      cache: ct(e.pluralRules),
      strategy: lt.variadic
    })
  };
}
var Un = (
  /** @class */
  function() {
    function e(t, n, r, o) {
      n === void 0 && (n = e.defaultLocale);
      var i = this;
      if (this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(c) {
        var l = i.formatToParts(c);
        if (l.length === 1)
          return l[0].value;
        var u = l.reduce(function(h, d) {
          return !h.length || d.type !== G.literal || typeof h[h.length - 1] != "string" ? h.push(d.value) : h[h.length - 1] += d.value, h;
        }, []);
        return u.length <= 1 ? u[0] || "" : u;
      }, this.formatToParts = function(c) {
        return Fe(i.ast, i.locales, i.formatters, i.formats, c, void 0, i.message);
      }, this.resolvedOptions = function() {
        var c;
        return {
          locale: ((c = i.resolvedLocale) === null || c === void 0 ? void 0 : c.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var a = o || {};
        a.formatters;
        var s = jr(a, ["formatters"]);
        this.ast = e.__parse(t, S(S({}, s), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Mo(e.formats, r), this.formatters = o && o.formatters || Po(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var n = Intl.NumberFormat.supportedLocalesOf(t);
        return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = To, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
);
function Oo(e, t) {
  if (t == null)
    return;
  if (t in e)
    return e[t];
  const n = t.split(".");
  let r = e;
  for (let o = 0; o < n.length; o++)
    if (typeof r == "object") {
      if (o > 0) {
        const i = n.slice(o, n.length).join(".");
        if (i in r) {
          r = r[i];
          break;
        }
      }
      r = r[n[o]];
    } else
      r = void 0;
  return r;
}
const Q = {}, Co = (e, t, n) => n && (t in Q || (Q[t] = {}), e in Q[t] || (Q[t][e] = n), n), Fn = (e, t) => {
  if (t == null)
    return;
  if (t in Q && e in Q[t])
    return Q[t][e];
  const n = Pe(t);
  for (let r = 0; r < n.length; r++) {
    const o = n[r], i = Ro(o, e);
    if (i)
      return Co(e, t, i);
  }
};
let Nt;
const Me = Xe({});
function Io(e) {
  return Nt[e] || null;
}
function kn(e) {
  return e in Nt;
}
function Ro(e, t) {
  if (!kn(e))
    return null;
  const n = Io(e);
  return Oo(n, t);
}
function Go(e) {
  if (e == null)
    return;
  const t = Pe(e);
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (kn(r))
      return r;
  }
}
function Lt(e, ...t) {
  delete Q[e], Me.update((n) => (n[e] = kr.all([n[e] || {}, ...t]), n));
}
be(
  [Me],
  ([e]) => Object.keys(e)
);
Me.subscribe((e) => Nt = e);
const ke = {};
function Do(e, t) {
  ke[e].delete(t), ke[e].size === 0 && delete ke[e];
}
function jn(e) {
  return ke[e];
}
function Uo(e) {
  return Pe(e).map((t) => {
    const n = jn(t);
    return [t, n ? [...n] : []];
  }).filter(([, t]) => t.length > 0);
}
function $e(e) {
  return e == null ? !1 : Pe(e).some(
    (t) => {
      var n;
      return (n = jn(t)) == null ? void 0 : n.size;
    }
  );
}
function Fo(e, t) {
  return Promise.all(
    t.map((r) => (Do(e, r), r().then((o) => o.default || o)))
  ).then((r) => Lt(e, ...r));
}
const xe = {};
function Vn(e) {
  if (!$e(e))
    return e in xe ? xe[e] : Promise.resolve();
  const t = Uo(e);
  return xe[e] = Promise.all(
    t.map(
      ([n, r]) => Fo(n, r)
    )
  ).then(() => {
    if ($e(e))
      return Vn(e);
    delete xe[e];
  }), xe[e];
}
var Yt = Object.getOwnPropertySymbols, ko = Object.prototype.hasOwnProperty, jo = Object.prototype.propertyIsEnumerable, Vo = (e, t) => {
  var n = {};
  for (var r in e)
    ko.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Yt)
    for (var r of Yt(e))
      t.indexOf(r) < 0 && jo.call(e, r) && (n[r] = e[r]);
  return n;
};
const $o = {
  number: {
    scientific: { notation: "scientific" },
    engineering: { notation: "engineering" },
    compactLong: { notation: "compact", compactDisplay: "long" },
    compactShort: { notation: "compact", compactDisplay: "short" }
  },
  date: {
    short: { month: "numeric", day: "numeric", year: "2-digit" },
    medium: { month: "short", day: "numeric", year: "numeric" },
    long: { month: "long", day: "numeric", year: "numeric" },
    full: { weekday: "long", month: "long", day: "numeric", year: "numeric" }
  },
  time: {
    short: { hour: "numeric", minute: "numeric" },
    medium: { hour: "numeric", minute: "numeric", second: "numeric" },
    long: {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZoneName: "short"
    },
    full: {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZoneName: "short"
    }
  }
};
function Wo({ locale: e, id: t }) {
  console.warn(
    `[svelte-i18n] The message "${t}" was not found in "${Pe(
      e
    ).join('", "')}".${$e(te()) ? `

Note: there are at least one loader still registered to this locale that wasn't executed.` : ""}`
  );
}
const zo = {
  fallbackLocale: null,
  loadingDelay: 200,
  formats: $o,
  warnOnMissingMessages: !0,
  handleMissingMessage: void 0,
  ignoreTag: !0
}, we = zo;
function me() {
  return we;
}
function Xo(e) {
  const t = e, { formats: n } = t, r = Vo(t, ["formats"]);
  let o = e.fallbackLocale;
  if (e.initialLocale)
    try {
      Un.resolveLocale(e.initialLocale) && (o = e.initialLocale);
    } catch {
      console.warn(
        `[svelte-i18n] The initial locale "${e.initialLocale}" is not a valid locale.`
      );
    }
  return r.warnOnMissingMessages && (delete r.warnOnMissingMessages, r.handleMissingMessage == null ? r.handleMissingMessage = Wo : console.warn(
    '[svelte-i18n] The "warnOnMissingMessages" option is deprecated. Please use the "handleMissingMessage" option instead.'
  )), Object.assign(we, r, { initialLocale: o }), n && ("number" in n && Object.assign(we.formats.number, n.number), "date" in n && Object.assign(we.formats.date, n.date), "time" in n && Object.assign(we.formats.time, n.time)), ve.set(o);
}
const ht = Xe(!1);
var Zo = Object.defineProperty, qo = Object.defineProperties, Jo = Object.getOwnPropertyDescriptors, Qt = Object.getOwnPropertySymbols, Ko = Object.prototype.hasOwnProperty, Yo = Object.prototype.propertyIsEnumerable, en = (e, t, n) => t in e ? Zo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Qo = (e, t) => {
  for (var n in t || (t = {}))
    Ko.call(t, n) && en(e, n, t[n]);
  if (Qt)
    for (var n of Qt(t))
      Yo.call(t, n) && en(e, n, t[n]);
  return e;
}, ei = (e, t) => qo(e, Jo(t));
let St;
const We = Xe(null);
function tn(e) {
  return e.split("-").map((t, n, r) => r.slice(0, n + 1).join("-")).reverse();
}
function Pe(e, t = me().fallbackLocale) {
  const n = tn(e);
  return t ? [.../* @__PURE__ */ new Set([...n, ...tn(t)])] : n;
}
function te() {
  return St ?? void 0;
}
We.subscribe((e) => {
  St = e ?? void 0, typeof window < "u" && e != null && document.documentElement.setAttribute("lang", e);
});
const ti = (e) => {
  if (e && Go(e) && $e(e)) {
    const { loadingDelay: t } = me();
    let n;
    return typeof window < "u" && te() != null && t ? n = window.setTimeout(
      () => ht.set(!0),
      t
    ) : ht.set(!0), Vn(e).then(() => {
      We.set(e);
    }).finally(() => {
      clearTimeout(n), ht.set(!1);
    });
  }
  return We.set(e);
}, ve = ei(Qo({}, We), {
  set: ti
}), Je = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (r) => {
    const o = JSON.stringify(r);
    return o in t ? t[o] : t[o] = e(r);
  };
};
var ni = Object.defineProperty, ze = Object.getOwnPropertySymbols, $n = Object.prototype.hasOwnProperty, Wn = Object.prototype.propertyIsEnumerable, nn = (e, t, n) => t in e ? ni(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Mt = (e, t) => {
  for (var n in t || (t = {}))
    $n.call(t, n) && nn(e, n, t[n]);
  if (ze)
    for (var n of ze(t))
      Wn.call(t, n) && nn(e, n, t[n]);
  return e;
}, _e = (e, t) => {
  var n = {};
  for (var r in e)
    $n.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && ze)
    for (var r of ze(e))
      t.indexOf(r) < 0 && Wn.call(e, r) && (n[r] = e[r]);
  return n;
};
const Ne = (e, t) => {
  const { formats: n } = me();
  if (e in n && t in n[e])
    return n[e][t];
  throw new Error(`[svelte-i18n] Unknown "${t}" ${e} format.`);
}, ri = Je(
  (e) => {
    var t = e, { locale: n, format: r } = t, o = _e(t, ["locale", "format"]);
    if (n == null)
      throw new Error('[svelte-i18n] A "locale" must be set to format numbers');
    return r && (o = Ne("number", r)), new Intl.NumberFormat(n, o);
  }
), oi = Je(
  (e) => {
    var t = e, { locale: n, format: r } = t, o = _e(t, ["locale", "format"]);
    if (n == null)
      throw new Error('[svelte-i18n] A "locale" must be set to format dates');
    return r ? o = Ne("date", r) : Object.keys(o).length === 0 && (o = Ne("date", "short")), new Intl.DateTimeFormat(n, o);
  }
), ii = Je(
  (e) => {
    var t = e, { locale: n, format: r } = t, o = _e(t, ["locale", "format"]);
    if (n == null)
      throw new Error(
        '[svelte-i18n] A "locale" must be set to format time values'
      );
    return r ? o = Ne("time", r) : Object.keys(o).length === 0 && (o = Ne("time", "short")), new Intl.DateTimeFormat(n, o);
  }
), ai = (e = {}) => {
  var t = e, {
    locale: n = te()
  } = t, r = _e(t, [
    "locale"
  ]);
  return ri(Mt({ locale: n }, r));
}, si = (e = {}) => {
  var t = e, {
    locale: n = te()
  } = t, r = _e(t, [
    "locale"
  ]);
  return oi(Mt({ locale: n }, r));
}, li = (e = {}) => {
  var t = e, {
    locale: n = te()
  } = t, r = _e(t, [
    "locale"
  ]);
  return ii(Mt({ locale: n }, r));
}, ui = Je(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  (e, t = te()) => new Un(e, t, me().formats, {
    ignoreTag: me().ignoreTag
  })
), ci = (e, t = {}) => {
  var n, r, o, i;
  let a = t;
  typeof e == "object" && (a = e, e = a.id);
  const {
    values: s,
    locale: c = te(),
    default: l
  } = a;
  if (c == null)
    throw new Error(
      "[svelte-i18n] Cannot format a message without first setting the initial locale."
    );
  let u = Fn(e, c);
  if (!u)
    u = (i = (o = (r = (n = me()).handleMissingMessage) == null ? void 0 : r.call(n, { locale: c, id: e, defaultValue: l })) != null ? o : l) != null ? i : e;
  else if (typeof u != "string")
    return console.warn(
      `[svelte-i18n] Message with id "${e}" must be of type "string", found: "${typeof u}". Gettin its value through the "$format" method is deprecated; use the "json" method instead.`
    ), u;
  if (!s)
    return u;
  let h = u;
  try {
    h = ui(u, c).format(s);
  } catch (d) {
    d instanceof Error && console.warn(
      `[svelte-i18n] Message "${e}" has syntax error:`,
      d.message
    );
  }
  return h;
}, hi = (e, t) => li(t).format(e), di = (e, t) => si(t).format(e), fi = (e, t) => ai(t).format(e), mi = (e, t = te()) => Fn(e, t), zn = be([ve, Me], () => ci);
be([ve], () => hi);
be([ve], () => di);
be([ve], () => fi);
be([ve, Me], () => mi);
const pi = "Ich komme aus der EU", gi = "Ich bin aus dem Rest der Welt", bi = "Deine neuen Lieblingsstücke erhältst du direkt von unserer Vertretung in deinem Land!", vi = "Wähle dazu bitte dein Land aus der Liste aus. Dein Warenkorb wird dann direkt an den richtigen Ansprechpartner weitergeleitet, über den die Abwicklung erfolgt.", _i = "Wähle dein Land", yi = "Land", Ei = "Name", Si = "Telefon", xi = "Senden", wi = "Abbrechen", Ti = "Benachrichtigung versendet", Ai = "Deine Anfrage wurde erfolgreich versendet. Ein Handelsparter oder wir werden uns in Kürze bei dir melden.", Bi = "Bitte wähle dein Land aus", Hi = "Bitte gib deinen Namen ein", Ni = "Bitte gib deine E-Mail Adresse ein", Li = "Bitte gib deine Lieferadresse ein", Mi = {
  iAmFromEurope: pi,
  restoftheworld: gi,
  header: bi,
  introtext: vi,
  selectcountry: _i,
  country: yi,
  Name: Ei,
  "E-Mail": "E-Mail",
  Phone: Si,
  send: xi,
  cancel: wi,
  "Shipping Address": "Lieferadresse",
  sheader: Ti,
  successfullsend: Ai,
  error_country: Bi,
  error_name: Hi,
  error_email: Ni,
  error_shippingaddress: Li
}, Pi = "I am from the EU", Oi = "I am from the Rest of the world", Ci = "Get your new favorite pieces directly from our sales partner in your country!", Ii = `Please select your country from the list. Your shopping cart will then be forwarded directly to the right sales
partner, who will be in touch with you soon.`, Ri = "Select your country", Gi = "Country", Di = "Name", Ui = "Phone", Fi = "Send", ki = "Cancel", ji = "Notification sent", Vi = "Your request has been successfully sent. A trading partner or we will contact you shortly.", $i = "Please select your country", Wi = "Please enter your name", zi = "Please enter your email address", Xi = "Please enter your shipping address", Zi = {
  iAmFromEurope: Pi,
  restoftheworld: Oi,
  header: Ci,
  introtext: Ii,
  selectcountry: Ri,
  country: Gi,
  Name: Di,
  "E-Mail": "E-Mail",
  Phone: Ui,
  send: Fi,
  cancel: ki,
  "Shipping Address": "Shipping Address",
  sheader: ji,
  successfullsend: Vi,
  error_country: $i,
  error_name: Wi,
  error_email: zi,
  error_shippingaddress: Xi
};
Lt("de", Mi);
Lt("en", Zi);
let qi = document.getElementsByTagName("html")[0].getAttribute("lang");
Xo({
  fallbackLocale: "en",
  initialLocale: qi
});
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(wr);
function Ji(e) {
  bn(e, "svelte-1slp9li", "button.w-full.svelte-1slp9li{width:90%;margin:1em auto}");
}
function Ki(e) {
  let t, n, r = (
    /*$_*/
    e[2]("iAmFromEurope") + ""
  ), o, i, a, s, c = (
    /*$_*/
    e[2]("restoftheworld") + ""
  ), l, u, h, d;
  return {
    c() {
      t = v("div"), n = v("button"), o = C(r), a = O(), s = v("button"), l = C(c), m(n, "class", i = "btn " + /*sidecart*/
      (e[1] ? "w-full" : "") + " svelte-1slp9li"), m(s, "class", u = "btn " + /*sidecart*/
      (e[1] ? "w-full" : "") + " svelte-1slp9li"), m(t, "class", "button-group");
    },
    m(p, g) {
      I(p, t, g), f(t, n), f(n, o), f(t, a), f(t, s), f(s, l), h || (d = [
        z(n, "click", dt(
          /*iamFromEurope*/
          e[3]
        )),
        z(s, "click", dt(ea))
      ], h = !0);
    },
    p(p, g) {
      g & /*$_*/
      4 && r !== (r = /*$_*/
      p[2]("iAmFromEurope") + "") && D(o, r), g & /*sidecart*/
      2 && i !== (i = "btn " + /*sidecart*/
      (p[1] ? "w-full" : "") + " svelte-1slp9li") && m(n, "class", i), g & /*$_*/
      4 && c !== (c = /*$_*/
      p[2]("restoftheworld") + "") && D(l, c), g & /*sidecart*/
      2 && u !== (u = "btn " + /*sidecart*/
      (p[1] ? "w-full" : "") + " svelte-1slp9li") && m(s, "class", u);
    },
    i: U,
    o: U,
    d(p) {
      p && M(t), h = !1, ee(d);
    }
  };
}
function Yi(e) {
  let t;
  const n = (
    /*#slots*/
    e[5].default
  ), r = sr(
    n,
    e,
    /*$$scope*/
    e[4],
    null
  );
  return {
    c() {
      r && r.c();
    },
    m(o, i) {
      r && r.m(o, i), t = !0;
    },
    p(o, i) {
      r && r.p && (!t || i & /*$$scope*/
      16) && ur(
        r,
        n,
        o,
        /*$$scope*/
        o[4],
        t ? lr(
          n,
          /*$$scope*/
          o[4],
          i,
          null
        ) : cr(
          /*$$scope*/
          o[4]
        ),
        null
      );
    },
    i(o) {
      t || (Ve(r, o), t = !0);
    },
    o(o) {
      mt(r, o), t = !1;
    },
    d(o) {
      r && r.d(o);
    }
  };
}
function Qi(e) {
  let t, n, r, o;
  const i = [Yi, Ki], a = [];
  function s(c, l) {
    return (
      /*fromEurope*/
      c[0] ? 0 : 1
    );
  }
  return n = s(e), r = a[n] = i[n](e), {
    c() {
      t = v("div"), r.c();
    },
    m(c, l) {
      I(c, t, l), a[n].m(t, null), o = !0;
    },
    p(c, [l]) {
      let u = n;
      n = s(c), n === u ? a[n].p(c, l) : (_r(), mt(a[u], 1, 1, () => {
        a[u] = null;
      }), yr(), r = a[n], r ? r.p(c, l) : (r = a[n] = i[n](c), r.c()), Ve(r, 1), r.m(t, null));
    },
    i(c) {
      o || (Ve(r), o = !0);
    },
    o(c) {
      mt(r), o = !1;
    },
    d(c) {
      c && M(t), a[n].d();
    }
  };
}
function ea() {
  const e = new Event("openLangsfCountrySelectionFrom");
  document.dispatchEvent(e);
}
function ta(e, t, n) {
  let r;
  pn(e, zn, (l) => n(2, r = l));
  let { $$slots: o = {}, $$scope: i } = t;
  function a() {
    n(0, s = !0);
  }
  let s = !1, c = !1;
  return window.location.pathname != "/cart" && (c = !0), e.$$set = (l) => {
    "$$scope" in l && n(4, i = l.$$scope);
  }, [s, c, r, a, i, o];
}
class na extends En {
  constructor(t) {
    super(), yn(this, t, ta, Qi, wt, {}, Ji);
  }
}
function ra(e) {
  if (Array.isArray(e)) {
    for (var t = 0, n = Array(e.length); t < e.length; t++)
      n[t] = e[t];
    return n;
  } else
    return Array.from(e);
}
var Ke = !1;
if (typeof window < "u") {
  var rn = {
    get passive() {
      Ke = !0;
    }
  };
  window.addEventListener("testPassive", null, rn), window.removeEventListener("testPassive", null, rn);
}
var pe = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), J = [], ge = !1, Pt = -1, Ae = void 0, re = void 0, Be = void 0, Xn = function(t) {
  return J.some(function(n) {
    return !!(n.options.allowTouchMove && n.options.allowTouchMove(t));
  });
}, Le = function(t) {
  var n = t || window.event;
  return Xn(n.target) || n.touches.length > 1 ? !0 : (n.preventDefault && n.preventDefault(), !1);
}, oa = function(t) {
  if (Be === void 0) {
    var n = !!t && t.reserveScrollBarGap === !0, r = window.innerWidth - document.documentElement.clientWidth;
    if (n && r > 0) {
      var o = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
      Be = document.body.style.paddingRight, document.body.style.paddingRight = o + r + "px";
    }
  }
  Ae === void 0 && (Ae = document.body.style.overflow, document.body.style.overflow = "hidden");
}, Zn = function() {
  Be !== void 0 && (document.body.style.paddingRight = Be, Be = void 0), Ae !== void 0 && (document.body.style.overflow = Ae, Ae = void 0);
}, ia = function() {
  return window.requestAnimationFrame(function() {
    if (re === void 0) {
      re = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };
      var t = window, n = t.scrollY, r = t.scrollX, o = t.innerHeight;
      document.body.style.position = "fixed", document.body.style.top = -n, document.body.style.left = -r, setTimeout(function() {
        return window.requestAnimationFrame(function() {
          var i = o - window.innerHeight;
          i && n >= o && (document.body.style.top = -(n + i));
        });
      }, 300);
    }
  });
}, qn = function() {
  if (re !== void 0) {
    var t = -parseInt(document.body.style.top, 10), n = -parseInt(document.body.style.left, 10);
    document.body.style.position = re.position, document.body.style.top = re.top, document.body.style.left = re.left, window.scrollTo(n, t), re = void 0;
  }
}, aa = function(t) {
  return t ? t.scrollHeight - t.scrollTop <= t.clientHeight : !1;
}, sa = function(t, n) {
  var r = t.targetTouches[0].clientY - Pt;
  return Xn(t.target) ? !1 : n && n.scrollTop === 0 && r > 0 || aa(n) && r < 0 ? Le(t) : (t.stopPropagation(), !0);
}, la = function(t, n) {
  if (!t) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!J.some(function(o) {
    return o.targetElement === t;
  })) {
    var r = {
      targetElement: t,
      options: n || {}
    };
    J = [].concat(ra(J), [r]), pe ? ia() : oa(n), pe && (t.ontouchstart = function(o) {
      o.targetTouches.length === 1 && (Pt = o.targetTouches[0].clientY);
    }, t.ontouchmove = function(o) {
      o.targetTouches.length === 1 && sa(o, t);
    }, ge || (document.addEventListener("touchmove", Le, Ke ? { passive: !1 } : void 0), ge = !0));
  }
}, ua = function() {
  pe && (J.forEach(function(t) {
    t.targetElement.ontouchstart = null, t.targetElement.ontouchmove = null;
  }), ge && (document.removeEventListener("touchmove", Le, Ke ? { passive: !1 } : void 0), ge = !1), Pt = -1), pe ? qn() : Zn(), J = [];
}, ca = function(t) {
  if (!t) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  J = J.filter(function(n) {
    return n.targetElement !== t;
  }), pe && (t.ontouchstart = null, t.ontouchmove = null, ge && J.length === 0 && (document.removeEventListener("touchmove", Le, Ke ? { passive: !1 } : void 0), ge = !1)), pe ? qn() : Zn();
};
function ha(e) {
  bn(e, "svelte-18c4g9m", "div.alert.svelte-18c4g9m.svelte-18c4g9m{border:1px solid red;background-color:lightpink;margin:1em 0;padding:0 1em}#form.svelte-18c4g9m.svelte-18c4g9m{max-width:1024px;display:grid;grid-template-columns:auto 1fr;gap:1em}#form.svelte-18c4g9m label.svelte-18c4g9m{font-weight:bold}#form.svelte-18c4g9m input.svelte-18c4g9m,#form.svelte-18c4g9m select.svelte-18c4g9m,#form.svelte-18c4g9m textarea.svelte-18c4g9m{width:100%}.modal-backdrop.svelte-18c4g9m.svelte-18c4g9m{font-size:1.25rem;font-weight:400;line-height:1.5;color:#575756;text-align:left;letter-spacing:0.04em;box-sizing:inherit;background:rgba(0, 0, 0, 0.3);position:fixed;z-index:10000;top:0;left:0;width:100vw;height:100vh;opacity:0;transition:opacity 0.35s linear 0s;pointer-events:none}.modal-backdrop.open.svelte-18c4g9m.svelte-18c4g9m{opacity:1;pointer-events:auto}.modal.svelte-18c4g9m.svelte-18c4g9m{position:fixed;top:0;display:none;border:none;width:100%;height:100%;align-content:center;justify-items:center;justify-self:center;overflow-y:scroll;color:#575756;left:0;z-index:10001;font-size:1.2rem}.modal.svelte-18c4g9m input.svelte-18c4g9m,.modal.svelte-18c4g9m select.svelte-18c4g9m,.modal.svelte-18c4g9m textarea.svelte-18c4g9m{font-size:1.2rem}@media(max-width: 1000px){.modal.svelte-18c4g9m input.svelte-18c4g9m,.modal.svelte-18c4g9m select.svelte-18c4g9m,.modal.svelte-18c4g9m textarea.svelte-18c4g9m{font-size:1rem}}@media(max-width: 1000px){.modal.svelte-18c4g9m.svelte-18c4g9m{font-size:1rem}}.modal.open.svelte-18c4g9m.svelte-18c4g9m{display:block;opacity:1}.modal.svelte-18c4g9m .modal-dialog.svelte-18c4g9m{display:grid;grid-template-rows:auto 1fr auto;width:95vw;max-width:1056px;background:white;overflow:hidden}.modal.svelte-18c4g9m .modal-dialog .modal-header.svelte-18c4g9m{background-color:#0050a0;color:#ffffff;display:grid;grid-template-columns:1fr auto;padding:1rem 1rem 0 1rem}.modal.svelte-18c4g9m .modal-dialog .modal-header button.svelte-18c4g9m{background:none;border:none;cursor:pointer;color:white;font-size:1.5rem}@media(max-width: 1000px){.modal.svelte-18c4g9m .modal-dialog .modal-header button.svelte-18c4g9m{font-size:1.1rem}}.modal.svelte-18c4g9m .modal-dialog .modal-content.svelte-18c4g9m{padding:1rem}.modal.svelte-18c4g9m .modal-dialog .modal-footer.svelte-18c4g9m{display:grid;grid-template-columns:1fr 1fr;background:#f0f0f0}.modal.svelte-18c4g9m .modal-dialog .modal-footer button.svelte-18c4g9m{margin:1em;cursor:pointer;color:#FFFFFF;background-color:#0050a0;font-size:1.5rem;border:none;padding:0.2em}@media(max-width: 1000px){.modal.svelte-18c4g9m .modal-dialog .modal-footer button.svelte-18c4g9m{font-size:1.1rem}}.modal.svelte-18c4g9m sup.svelte-18c4g9m{color:red;font-weight:bold}");
}
function on(e, t, n) {
  const r = e.slice();
  return r[22] = t[n], r[24] = n, r;
}
function an(e, t, n) {
  const r = e.slice();
  return r[22] = t[n], r[24] = n, r;
}
function sn(e, t, n) {
  const r = e.slice();
  return r[26] = t[n], r;
}
function da(e) {
  let t, n = (
    /*$_*/
    e[8]("header") + ""
  ), r;
  return {
    c() {
      t = v("h2"), r = C(n), m(t, "class", "h2");
    },
    m(o, i) {
      I(o, t, i), f(t, r);
    },
    p(o, i) {
      i & /*$_*/
      256 && n !== (n = /*$_*/
      o[8]("header") + "") && D(r, n);
    },
    d(o) {
      o && M(t);
    }
  };
}
function fa(e) {
  let t, n = (
    /*$_*/
    e[8]("sheader") + ""
  ), r;
  return {
    c() {
      t = v("h2"), r = C(n), m(t, "class", "h2");
    },
    m(o, i) {
      I(o, t, i), f(t, r);
    },
    p(o, i) {
      i & /*$_*/
      256 && n !== (n = /*$_*/
      o[8]("sheader") + "") && D(r, n);
    },
    d(o) {
      o && M(t);
    }
  };
}
function ma(e) {
  let t, n, r = (
    /*$_*/
    e[8]("introtext") + ""
  ), o, i, a, s, c, l = (
    /*$_*/
    e[8]("country") + ""
  ), u, h, d, p, g, b, P = (
    /*$_*/
    e[8]("Name") + ""
  ), R, x, y, w, V, j, Z = (
    /*$_*/
    e[8]("E-Mail") + ""
  ), ye, N, B, H, F, q, K = (
    /*$_*/
    e[8]("Phone") + ""
  ), $, Ot, Y, Ct, ie, Oe = (
    /*$_*/
    e[8]("Shipping Address") + ""
  ), Ye, Ce, It, W, Qe, ne, Ee, Ie = (
    /*$_*/
    e[8]("cancel") + ""
  ), et, Rt, Se, Re = (
    /*$_*/
    e[8]("send") + ""
  ), tt, nt, Gt, k = (
    /*errors*/
    e[7].length > 0 && ln(e)
  );
  function Jn(T, L) {
    return document.getElementsByTagName("html")[0].getAttribute("lang") === "de" ? ba : ga;
  }
  let Ge = Jn()(e);
  return {
    c() {
      t = v("div"), n = v("p"), o = C(r), i = O(), k && k.c(), a = O(), s = v("div"), c = v("label"), u = C(l), h = v("sup"), h.textContent = "*", d = O(), p = v("select"), Ge.c(), g = O(), b = v("label"), R = C(P), x = v("sup"), x.textContent = "*", y = O(), w = v("input"), V = O(), j = v("label"), ye = C(Z), N = v("sup"), N.textContent = "*", B = O(), H = v("input"), F = O(), q = v("label"), $ = C(K), Ot = O(), Y = v("input"), Ct = O(), ie = v("label"), Ye = C(Oe), Ce = v("sup"), Ce.textContent = "*", It = O(), W = v("textarea"), Qe = O(), ne = v("div"), Ee = v("button"), et = C(Ie), Rt = O(), Se = v("button"), tt = C(Re), m(h, "class", "svelte-18c4g9m"), m(c, "for", "countryselect"), m(c, "class", "svelte-18c4g9m"), m(p, "id", "countryselect"), m(p, "class", "svelte-18c4g9m"), /*usercountry*/
      e[1] === void 0 && je(() => (
        /*select_change_handler*/
        e[14].call(p)
      )), m(x, "class", "svelte-18c4g9m"), m(b, "for", "nameinput"), m(b, "class", "svelte-18c4g9m"), w.required = !0, m(w, "id", "nameinput"), m(w, "type", "text"), m(w, "class", "svelte-18c4g9m"), m(N, "class", "svelte-18c4g9m"), m(j, "for", "mailinput"), m(j, "class", "svelte-18c4g9m"), H.required = !0, m(H, "id", "mailinput"), m(H, "type", "email"), m(H, "class", "svelte-18c4g9m"), m(q, "for", "phoneinput"), m(q, "class", "svelte-18c4g9m"), m(Y, "type", "tel"), m(Y, "id", "phoneinput"), m(Y, "class", "svelte-18c4g9m"), m(Ce, "class", "svelte-18c4g9m"), m(ie, "for", "shippinginput"), m(ie, "class", "svelte-18c4g9m"), W.required = !0, m(W, "id", "shippinginput"), m(W, "type", ""), m(W, "rows", "4"), m(W, "cols", "50"), m(W, "class", "svelte-18c4g9m"), m(s, "id", "form"), m(s, "class", "svelte-18c4g9m"), m(t, "class", "modal-content svelte-18c4g9m"), m(Ee, "class", "svelte-18c4g9m"), m(Se, "class", "svelte-18c4g9m"), m(ne, "class", "modal-footer svelte-18c4g9m");
    },
    m(T, L) {
      I(T, t, L), f(t, n), f(n, o), f(t, i), k && k.m(t, null), f(t, a), f(t, s), f(s, c), f(c, u), f(c, h), f(s, d), f(s, p), Ge.m(p, null), Ft(
        p,
        /*usercountry*/
        e[1],
        !0
      ), f(s, g), f(s, b), f(b, R), f(b, x), f(s, y), f(s, w), X(
        w,
        /*username*/
        e[2]
      ), f(s, V), f(s, j), f(j, ye), f(j, N), f(s, B), f(s, H), X(
        H,
        /*useremail*/
        e[3]
      ), f(s, F), f(s, q), f(q, $), f(s, Ot), f(s, Y), X(
        Y,
        /*userphone*/
        e[4]
      ), f(s, Ct), f(s, ie), f(ie, Ye), f(ie, Ce), f(s, It), f(s, W), X(
        W,
        /*usershippingaddress*/
        e[5]
      ), I(T, Qe, L), I(T, ne, L), f(ne, Ee), f(Ee, et), f(ne, Rt), f(ne, Se), f(Se, tt), nt || (Gt = [
        z(
          p,
          "change",
          /*select_change_handler*/
          e[14]
        ),
        z(
          w,
          "input",
          /*input0_input_handler*/
          e[15]
        ),
        z(
          H,
          "input",
          /*input1_input_handler*/
          e[16]
        ),
        z(
          Y,
          "input",
          /*input2_input_handler*/
          e[17]
        ),
        z(
          W,
          "input",
          /*textarea_input_handler*/
          e[18]
        ),
        z(
          Ee,
          "click",
          /*closeModal*/
          e[11]
        ),
        z(
          Se,
          "click",
          /*sendForm*/
          e[13]
        )
      ], nt = !0);
    },
    p(T, L) {
      L & /*$_*/
      256 && r !== (r = /*$_*/
      T[8]("introtext") + "") && D(o, r), /*errors*/
      T[7].length > 0 ? k ? k.p(T, L) : (k = ln(T), k.c(), k.m(t, a)) : k && (k.d(1), k = null), L & /*$_*/
      256 && l !== (l = /*$_*/
      T[8]("country") + "") && D(u, l), Ge.p(T, L), L & /*usercountry, coutrylist, coutrylistenglish*/
      1538 && Ft(
        p,
        /*usercountry*/
        T[1]
      ), L & /*$_*/
      256 && P !== (P = /*$_*/
      T[8]("Name") + "") && D(R, P), L & /*username*/
      4 && w.value !== /*username*/
      T[2] && X(
        w,
        /*username*/
        T[2]
      ), L & /*$_*/
      256 && Z !== (Z = /*$_*/
      T[8]("E-Mail") + "") && D(ye, Z), L & /*useremail*/
      8 && H.value !== /*useremail*/
      T[3] && X(
        H,
        /*useremail*/
        T[3]
      ), L & /*$_*/
      256 && K !== (K = /*$_*/
      T[8]("Phone") + "") && D($, K), L & /*userphone*/
      16 && X(
        Y,
        /*userphone*/
        T[4]
      ), L & /*$_*/
      256 && Oe !== (Oe = /*$_*/
      T[8]("Shipping Address") + "") && D(Ye, Oe), L & /*usershippingaddress*/
      32 && X(
        W,
        /*usershippingaddress*/
        T[5]
      ), L & /*$_*/
      256 && Ie !== (Ie = /*$_*/
      T[8]("cancel") + "") && D(et, Ie), L & /*$_*/
      256 && Re !== (Re = /*$_*/
      T[8]("send") + "") && D(tt, Re);
    },
    d(T) {
      T && (M(t), M(Qe), M(ne)), k && k.d(), Ge.d(), nt = !1, ee(Gt);
    }
  };
}
function pa(e) {
  let t, n, r = (
    /*$_*/
    e[8]("successfullsend") + ""
  ), o, i, a, s, c, l, u = (
    /*$_*/
    e[8]("close") + ""
  ), h, d, p;
  return {
    c() {
      t = v("div"), n = v("p"), o = C(r), i = O(), a = v("div"), s = v("span"), c = O(), l = v("button"), h = C(u), m(t, "class", "modal-content svelte-18c4g9m"), m(l, "class", "svelte-18c4g9m"), m(a, "class", "modal-footer svelte-18c4g9m");
    },
    m(g, b) {
      I(g, t, b), f(t, n), f(n, o), I(g, i, b), I(g, a, b), f(a, s), f(a, c), f(a, l), f(l, h), d || (p = z(
        l,
        "click",
        /*closeModaldone*/
        e[12]
      ), d = !0);
    },
    p(g, b) {
      b & /*$_*/
      256 && r !== (r = /*$_*/
      g[8]("successfullsend") + "") && D(o, r), b & /*$_*/
      256 && u !== (u = /*$_*/
      g[8]("close") + "") && D(h, u);
    },
    d(g) {
      g && (M(t), M(i), M(a)), d = !1, p();
    }
  };
}
function ln(e) {
  let t, n = ce(
    /*errors*/
    e[7]
  ), r = [];
  for (let o = 0; o < n.length; o += 1)
    r[o] = un(sn(e, n, o));
  return {
    c() {
      t = v("div");
      for (let o = 0; o < r.length; o += 1)
        r[o].c();
      m(t, "class", "alert alert-danger svelte-18c4g9m");
    },
    m(o, i) {
      I(o, t, i);
      for (let a = 0; a < r.length; a += 1)
        r[a] && r[a].m(t, null);
    },
    p(o, i) {
      if (i & /*errors*/
      128) {
        n = ce(
          /*errors*/
          o[7]
        );
        let a;
        for (a = 0; a < n.length; a += 1) {
          const s = sn(o, n, a);
          r[a] ? r[a].p(s, i) : (r[a] = un(s), r[a].c(), r[a].m(t, null));
        }
        for (; a < r.length; a += 1)
          r[a].d(1);
        r.length = n.length;
      }
    },
    d(o) {
      o && M(t), Tt(r, o);
    }
  };
}
function un(e) {
  let t, n = (
    /*error*/
    e[26] + ""
  ), r;
  return {
    c() {
      t = v("p"), r = C(n);
    },
    m(o, i) {
      I(o, t, i), f(t, r);
    },
    p(o, i) {
      i & /*errors*/
      128 && n !== (n = /*error*/
      o[26] + "") && D(r, n);
    },
    d(o) {
      o && M(t);
    }
  };
}
function ga(e) {
  let t, n = ce(
    /*coutrylistenglish*/
    e[10]
  ), r = [];
  for (let o = 0; o < n.length; o += 1)
    r[o] = cn(on(e, n, o));
  return {
    c() {
      for (let o = 0; o < r.length; o += 1)
        r[o].c();
      t = vn();
    },
    m(o, i) {
      for (let a = 0; a < r.length; a += 1)
        r[a] && r[a].m(o, i);
      I(o, t, i);
    },
    p(o, i) {
      if (i & /*coutrylistenglish*/
      1024) {
        n = ce(
          /*coutrylistenglish*/
          o[10]
        );
        let a;
        for (a = 0; a < n.length; a += 1) {
          const s = on(o, n, a);
          r[a] ? r[a].p(s, i) : (r[a] = cn(s), r[a].c(), r[a].m(t.parentNode, t));
        }
        for (; a < r.length; a += 1)
          r[a].d(1);
        r.length = n.length;
      }
    },
    d(o) {
      o && M(t), Tt(r, o);
    }
  };
}
function ba(e) {
  let t, n = ce(
    /*coutrylist*/
    e[9]
  ), r = [];
  for (let o = 0; o < n.length; o += 1)
    r[o] = hn(an(e, n, o));
  return {
    c() {
      for (let o = 0; o < r.length; o += 1)
        r[o].c();
      t = vn();
    },
    m(o, i) {
      for (let a = 0; a < r.length; a += 1)
        r[a] && r[a].m(o, i);
      I(o, t, i);
    },
    p(o, i) {
      if (i & /*coutrylist*/
      512) {
        n = ce(
          /*coutrylist*/
          o[9]
        );
        let a;
        for (a = 0; a < n.length; a += 1) {
          const s = an(o, n, a);
          r[a] ? r[a].p(s, i) : (r[a] = hn(s), r[a].c(), r[a].m(t.parentNode, t));
        }
        for (; a < r.length; a += 1)
          r[a].d(1);
        r.length = n.length;
      }
    },
    d(o) {
      o && M(t), Tt(r, o);
    }
  };
}
function cn(e) {
  let t, n = (
    /*contry*/
    e[22].name + ""
  ), r;
  return {
    c() {
      t = v("option"), r = C(n), t.selected = /*i*/
      e[24] === 0 ? "selected" : "", t.__value = /*contry*/
      e[22].code, X(t, t.__value);
    },
    m(o, i) {
      I(o, t, i), f(t, r);
    },
    p: U,
    d(o) {
      o && M(t);
    }
  };
}
function hn(e) {
  let t, n = (
    /*contry*/
    e[22].name + ""
  ), r;
  return {
    c() {
      t = v("option"), r = C(n), t.selected = /*i*/
      e[24] === 0 ? "selected" : "", t.__value = /*contry*/
      e[22].code, X(t, t.__value);
    },
    m(o, i) {
      I(o, t, i), f(t, r);
    },
    p: U,
    d(o) {
      o && M(t);
    }
  };
}
function va(e) {
  let t, n, r, o, i, a, s, c, l, u, h, d;
  function p(y, w) {
    return (
      /*successfullsend*/
      y[6] ? fa : da
    );
  }
  let g = p(e), b = g(e);
  function P(y, w) {
    return (
      /*successfullsend*/
      y[6] ? pa : ma
    );
  }
  let R = P(e), x = R(e);
  return {
    c() {
      t = v("div"), r = O(), o = v("div"), i = v("div"), a = v("div"), b.c(), s = O(), c = v("button"), c.innerHTML = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"><path d="M5.63086 14.3692L10 10L14.3692 14.3692M14.3692 5.63086L9.99919 10L5.63086 5.63086" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>', l = O(), x.c(), m(t, "class", n = "modal-backdrop " + /*open*/
      (e[0] ? "open" : "") + " svelte-18c4g9m"), m(c, "aria-label", "button"), m(c, "class", "svelte-18c4g9m"), m(a, "class", "modal-header svelte-18c4g9m"), m(i, "class", "modal-dialog svelte-18c4g9m"), m(o, "class", u = "modal " + /*open*/
      (e[0] ? "open" : "") + " svelte-18c4g9m"), m(o, "id", "svmodal-form");
    },
    m(y, w) {
      I(y, t, w), I(y, r, w), I(y, o, w), f(o, i), f(i, a), b.m(a, null), f(a, s), f(a, c), f(i, l), x.m(i, null), h || (d = z(c, "click", dt(
        /*closeModal*/
        e[11]
      )), h = !0);
    },
    p(y, [w]) {
      w & /*open*/
      1 && n !== (n = "modal-backdrop " + /*open*/
      (y[0] ? "open" : "") + " svelte-18c4g9m") && m(t, "class", n), g === (g = p(y)) && b ? b.p(y, w) : (b.d(1), b = g(y), b && (b.c(), b.m(a, s))), R === (R = P(y)) && x ? x.p(y, w) : (x.d(1), x = R(y), x && (x.c(), x.m(i, null))), w & /*open*/
      1 && u !== (u = "modal " + /*open*/
      (y[0] ? "open" : "") + " svelte-18c4g9m") && m(o, "class", u);
    },
    i: U,
    o: U,
    d(y) {
      y && (M(t), M(r), M(o)), b.d(), x.d(), h = !1, d();
    }
  };
}
function _a(e, t, n) {
  let r;
  pn(e, zn, (N) => n(8, r = N));
  const o = (N) => String(N).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  let i = !1, a = [
    { name: r("selectcountry"), code: "" },
    { name: "Afghanistan", code: "AF" },
    { name: "Ägypten", code: "EG" },
    { name: "Algerien", code: "DZ" },
    { name: "Angola", code: "AO" },
    { name: "Antigua und Barbuda", code: "AG" },
    { name: "Argentinien", code: "AR" },
    { name: "Australien", code: "AU" },
    { name: "Bahamas", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesch", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivien", code: "BO" },
    { name: "Botswana", code: "BW" },
    { name: "Brasilien", code: "BR" },
    { name: "Brunei", code: "BN" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Costa Rica", code: "CR" },
    { name: "Dominica", code: "DM" },
    {
      name: "Dominikanische Republik",
      code: "DO"
    },
    { name: "Dschibuti", code: "DJ" },
    { name: "Ecuador", code: "EC" },
    { name: "El Salvador", code: "SV" },
    { name: "Eritrea", code: "ER" },
    {
      name: "Eswatini (ehemals Swasiland)",
      code: "SZ"
    },
    { name: "Fidschi", code: "FJ" },
    { name: "Gabun", code: "GA" },
    { name: "Gambia", code: "GM" },
    { name: "Ghana", code: "GH" },
    { name: "Grenada", code: "GD" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Honduras", code: "HN" },
    { name: "Indien", code: "IN" },
    { name: "Indien", code: "IN" },
    { name: "Indonesien", code: "ID" },
    { name: "Irak", code: "IQ" },
    { name: "Iran", code: "IR" },
    { name: "Israel", code: "IL" },
    { name: "Jamaika", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jemen", code: "YE" },
    { name: "Jordanien", code: "JO" },
    { name: "Kambodscha", code: "KH" },
    { name: "Kamerun", code: "CM" },
    { name: "Kanada", code: "CA" },
    { name: "Kap Verde", code: "CV" },
    { name: "Kasachstan", code: "KZ" },
    { name: "Katar", code: "QA" },
    { name: "Kenia", code: "KE" },
    { name: "Kirgisistan", code: "KG" },
    { name: "Kiribati", code: "KI" },
    { name: "Kolumbien", code: "CO" },
    { name: "Komoren", code: "KM" },
    {
      name: "Kongo (Demokratische Republik)",
      code: "CD"
    },
    { name: "Korea", code: "KP" },
    { name: "Kuba", code: "CU" },
    { name: "Kuwait", code: "KW" },
    { name: "Laos", code: "LA" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libyen", code: "LY" },
    { name: "Madagaskar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Malediven", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Marokko", code: "MA" },
    { name: "Mauretanien", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mexiko", code: "MX" },
    { name: "Mikronesien", code: "FM" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "Neuseeland", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "Nordmazedonien", code: "MK" },
    { name: "Norwegen", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Papua-Neuguinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippinen", code: "PH" },
    { name: "Ruanda", code: "RW" },
    { name: "Sambia", code: "ZM" },
    { name: "Samoa", code: "WS" },
    {
      name: "São Tomé und Príncipe",
      code: "ST"
    },
    { name: "Saudi-Arabien", code: "SA" },
    { name: "Scheiz", code: "CH" },
    { name: "Senegal", code: "SN" },
    { name: "Seychellen", code: "SC" },
    { name: "Shanghai", code: "SH" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Simbabwe", code: "ZW" },
    { name: "Singapur", code: "SG" },
    { name: "Somalia", code: "SO" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Südafrika", code: "ZA" },
    { name: "Sudan", code: "SD" },
    { name: "Südsudan", code: "SS" },
    { name: "Suriname", code: "SR" },
    { name: "Syrien", code: "SY" },
    { name: "Tadschikistan", code: "TJ" },
    { name: "Taiwan", code: "TW" },
    { name: "Tansania", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad und Tobago", code: "TT" },
    { name: "Tunesien", code: "TN" },
    { name: "Türkei", code: "TR" },
    { name: "Uganda", code: "UG" },
    { name: "USA", code: "US" },
    { name: "Venezuela", code: "VE" },
    {
      name: "Vereinigte Arabische Emirate",
      code: "AE"
    },
    {
      name: "Vereinigtes Königreich",
      code: "UK"
    },
    { name: "Vietnam", code: "VN" },
    { name: "Weißrussland", code: "BY" }
  ], s = [
    { name: r("selectcountry"), code: "" },
    { name: "USA", code: "US" },
    { name: "United Kingdom", code: "UK" },
    { name: "Afghanistan", code: "AF" },
    { name: "Algeria", code: "DZ" },
    { name: "Angola", code: "AO" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Argentina", code: "AR" },
    { name: "Australia", code: "AU" },
    { name: "Bahamas", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivia", code: "BO" },
    { name: "Botswana", code: "BW" },
    { name: "Brazil", code: "BR" },
    { name: "Brunei", code: "BN" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cambodia", code: "KH" },
    { name: "Cameroon", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Cape Verde", code: "CV" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Colombia", code: "CO" },
    { name: "Comoros", code: "KM" },
    {
      name: "Congo (Democratic Republic)",
      code: "CD"
    },
    { name: "Costa Rica", code: "CR" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Djibouti", code: "DJ" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Eritrea", code: "ER" },
    {
      name: "Eswatini (formerly Swaziland)",
      code: "SZ"
    },
    { name: "Fiji", code: "FJ" },
    { name: "Gabon", code: "GA" },
    { name: "Gambia", code: "GM" },
    { name: "Ghana", code: "GH" },
    { name: "Grenada", code: "GD" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Honduras", code: "HN" },
    { name: "India", code: "IN" },
    { name: "Indonesia", code: "ID" },
    { name: "Iraq", code: "IQ" },
    { name: "Iran", code: "IR" },
    { name: "Israel", code: "IL" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kyrgyzstan", code: "KG" },
    { name: "Kiribati", code: "KI" },
    { name: "Korea", code: "KP" },
    { name: "Cuba", code: "CU" },
    { name: "Kuwait", code: "KW" },
    { name: "Laos", code: "LA" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libya", code: "LY" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Morocco", code: "MA" },
    { name: "Mauritania", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia", code: "FM" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "New Zealand", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "North Macedonia", code: "MK" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Papua New Guinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Qatar", code: "QA" },
    { name: "Rwanda", code: "RW" },
    { name: "Samoa", code: "WS" },
    {
      name: "São Tomé and Príncipe",
      code: "ST"
    },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Senegal", code: "SN" },
    { name: "Seychelles", code: "SC" },
    { name: "Shanghai", code: "SH" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapore", code: "SG" },
    { name: "Somalia", code: "SO" },
    { name: "Sri Lanka", code: "LK" },
    { name: "South Africa", code: "ZA" },
    { name: "Sudan", code: "SD" },
    { name: "South Sudan", code: "SS" },
    { name: "Suriname", code: "SR" },
    { name: "Switzerland", code: "CH" },
    { name: "Syria", code: "SY" },
    { name: "Tajikistan", code: "TJ" },
    { name: "Taiwan", code: "TW" },
    { name: "Tanzania", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Tunisia", code: "TN" },
    { name: "Turkey", code: "TR" },
    { name: "Uganda", code: "UG" },
    { name: "Venezuela", code: "VE" },
    { name: "United Arab Emirates", code: "AE" },
    { name: "Vietnam", code: "VN" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" }
  ], c, l, u, h = "", d, p = !1;
  document.addEventListener(
    "openLangsfCountrySelectionFrom",
    () => {
      console.log("openLangsfCountrySelectionFrom"), R();
    },
    !1
  );
  function g() {
    n(0, i = !1);
    let N = "svmodal-form", B = document.querySelector("#" + N);
    if (B) {
      let H = document.querySelector("#" + N + "_backdrop"), F = document.querySelector("body");
      H && H.classList.add("closing"), B.classList.add("closing"), setTimeout(
        function() {
          B.classList.remove("open"), B.classList.remove("closing"), H && (H.classList.remove("open"), H.classList.remove("closing")), F == null || F.classList.remove("modal-open"), H == null || H.remove(), document.querySelectorAll(".modal.open").length > 0 ? ca(B) : ua();
        },
        100
      );
    }
  }
  let b = {};
  function P() {
    g(), window.location.reload();
  }
  function R() {
    var H;
    let N = "svmodal-form", B = document.querySelector("#" + N);
    if (B) {
      let F = document.createElement("div");
      F.id = N + "_backdrop", F.classList.add("modal-backdrop", "open"), (H = document.querySelector("body")) == null || H.appendChild(F);
      let q = B.querySelector(".modal-close"), K = document.querySelector("body");
      F && (F.classList.add("open"), F.addEventListener("click", g)), B.classList.add("open"), n(0, i = !0), window.location.hash === "#sent" && B.classList.add("sent"), K == null || K.classList.add("modal-open"), q == null || q.addEventListener("click", g), la(B, {}), B.before(F), fetch("/cart.js", { method: "GET", cache: "no-cache" }).then(($) => {
        if (!$.ok)
          throw new Error("Network response was not ok");
        return $.json();
      }).then(($) => {
        b = $, console.log($);
      }).catch(($) => {
        console.error("Error fetching cart:", $);
      });
    }
  }
  let x = [];
  function y() {
    n(7, x = []), c === "" && x.push(r("error_country")), (l == null || l === "") && x.push(r("error_name")), (u == null || u === "" || o(u) == null) && x.push(r("error_email")), (d == null || d === "") && x.push(r("error_shippingaddress")), !(x.length > 0) && fetch("https://lang-sf-form.vgserver.de/postmessage.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cart: b,
        country: c,
        name: l,
        email: u,
        phone: h,
        shippingaddress: d
      })
    }).then((N) => {
      if (!N.ok)
        throw new Error("Network response was not ok");
      return N.json();
    }).then((N) => {
      console.log("Success:", N), n(6, p = !0), fetch("/cart/clear.js", { method: "POST", cache: "no-cache" }).then((B) => {
        if (!B.ok)
          throw new Error("Network response was not ok");
        return B.json();
      }).then((B) => {
        console.log("Cart cleared:", B);
      }).catch((B) => {
        console.error("Error clearing cart:", B);
      });
    }).catch((N) => {
      console.error("Error:", N);
    });
  }
  function w() {
    c = mr(this), n(1, c), n(9, a), n(10, s);
  }
  function V() {
    l = this.value, n(2, l);
  }
  function j() {
    u = this.value, n(3, u);
  }
  function Z() {
    h = this.value, n(4, h);
  }
  function ye() {
    d = this.value, n(5, d);
  }
  return [
    i,
    c,
    l,
    u,
    h,
    d,
    p,
    x,
    r,
    a,
    s,
    g,
    P,
    y,
    w,
    V,
    j,
    Z,
    ye
  ];
}
class ya extends En {
  constructor(t) {
    super(), yn(this, t, _a, va, wt, {}, ha);
  }
}
dn({
  component: na,
  tagname: "langsf-deliveryselection"
});
dn({
  component: ya,
  tagname: "langsf-restoftheworld"
});
